import { z } from 'zod'

const envSchema = z.object({
  VITE_APP_ENV: z.enum(['TEST', 'STAGING']),
  VITE_SUPABASE_URL: z.url().refine((value) => value.startsWith('https://') || value.startsWith('http://127.0.0.1'), {
    message: 'Use HTTPS ou o Supabase local em 127.0.0.1.',
  }),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().trim().startsWith('sb_publishable_'),
})

const result = envSchema.safeParse({
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_PUBLISHABLE_KEY: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
})

if (!result.success) {
  const fields = result.error.issues.map((issue) => issue.path.join('.')).join(', ')
  throw new Error(`Configuração obrigatória do Supabase inválida: ${fields}`)
}

export const env = Object.freeze(result.data)
